var cookiesMadeSimpleProperties = {
    showCookieDescription: cookies_made_simple_plugin_public_properties.showCookieDescription,
    showMandatoryCookies: cookies_made_simple_plugin_public_properties.showMandatoryCookies,
    isCookiesSelectionMandatory: cookies_made_simple_plugin_public_properties.forceCookiesSelection,
    areCookiesGroupedByCategory: cookies_made_simple_plugin_public_properties.areCookiesGroupedByCategory,
    getGlobalPrefix: cookies_made_simple_plugin_public_properties.globalPrefix,
    getCookieName: cookies_made_simple_plugin_public_properties.cookieName,
    getCookieValidityInDays: cookies_made_simple_plugin_public_properties.cookieValidityDays,
    getCookies: cookies_made_simple_plugin_public_properties.cookies
};
export { cookiesMadeSimpleProperties };
